module.exports = __webpack_public_path__ + "assets/resonance.aeeae000.svg";